var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0.75H14.75C14.9489 0.75 15.1397 0.829018 15.2803 0.96967C15.421 1.11032 15.5 1.30109 15.5 1.5V12.5C15.5 12.6989 15.421 12.8897 15.2803 13.0303C15.1397 13.171 14.9489 13.25 14.75 13.25H1.25C1.05109 13.25 0.860322 13.171 0.71967 13.0303C0.579018 12.8897 0.5 12.6989 0.5 12.5V1.5C0.5 1.30109 0.579018 1.11032 0.71967 0.96967C0.860322 0.829018 1.05109 0.75 1.25 0.75ZM14 3.9285L8.054 9.2535L2 3.912V11.75H14V3.9285ZM2.38325 2.25L8.04575 7.2465L13.6265 2.25H2.38325Z",
    fill: "#99A0AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.f2fef2448106392e769acc5172aaeec1.svg";
export { ForwardRef as ReactComponent };